import DynamicFlag from "@components/languages/DynamicFlag";

const ROOT = `https://storage.googleapis.com/eleven-public-cdn/images/marketing`;

export const asset = `${ROOT}/dubbing-hero.png`;

export const config = [
  {
    cover: `${ROOT}/colin-and-samir.jpg`,
    languages: [<DynamicFlag key='en' locale='en' />, <DynamicFlag key='es' locale='es' />],
  },
  {
    cover: `${ROOT}/harry-stebbings.jpg`,
    languages: [<DynamicFlag key='en' locale='en' />, <DynamicFlag key='hi' locale='hi' />],
  },
  {
    cover: `${ROOT}/aarthi-and-sriram.jpg`,
    languages: [
      <DynamicFlag key='en' locale='en' />,
      <DynamicFlag key='de' locale='de' />,
      <DynamicFlag key='pl' locale='pl' />,
      <DynamicFlag key='it' locale='it' />,
    ],
  },
];
